import locations from './locations/locationsSlice';

export default { locations };
